<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useAuth } from "@/composables/useAuth"; // 👈 IMPORTANTE

import Sidenav from "./quote/Sidenav";
import Navbar from "@/quote/Navbars/Navbar.vue";
import AppFooter from "@/quote/Footer.vue";
import Configurator from "@/quote/Configurator.vue";

const store = useStore();
const { user, loadUser } = useAuth(); // 👈

const isNavFixed = computed(() => store.state.isNavFixed);
const darkMode = computed(() => store.state.darkMode);
const isAbsolute = computed(() => store.state.isAbsolute);
const showSidenav = computed(() => store.state.showSidenav);
const layout = computed(() => store.state.layout);
const showNavbar = computed(() => store.state.showNavbar);
const showFooter = computed(() => store.state.showFooter);

const navClasses = computed(() => {
  return {
    "position-sticky bg-white left-auto top-2 z-index-sticky":
      isNavFixed.value && !darkMode.value,
    "position-sticky bg-default left-auto top-2 z-index-sticky":
      isNavFixed.value && darkMode.value,
    "position-absolute px-4 mx-0 w-100 z-index-2": isAbsolute.value,
    "px-0 mx-4": !isAbsolute.value,
  };
});

// 👇 AÑADE ESTO
onMounted(async () => {
  // Sincroniza el estado "isPinned" con el ancho real de pantalla ANTES de
  // cualquier interacción -- ver comentario en store/index.js (setInitialPinned)
  // sobre por qué hace falta esto para que el primer toque del hamburger
  // funcione en móvil.
  store.commit("setInitialPinned", window.innerWidth < 1200);

  if (!user.value) {
    await loadUser();
  }
});
</script>
<template>
  <div v-show="layout === 'landing'" class="landing-bg h-100 bg-gradient-primary position-fixed w-100"></div>

  <sidenav v-if="showSidenav" />

  <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg d-flex flex-column min-vh-100">
    <!-- nav -->

    <navbar :class="[navClasses]" v-if="showNavbar" />

    <router-view />

    <app-footer v-show="showFooter" />

  </main>

  <configurator />
</template>
